export interface AmountPercentagePair {
  amount?: number | null
  percentage?: number | null
}

export interface CostBreakdownAmountPercentageValues {
  amount: number | null
  percentage: number | null
}

export enum AmountPercentageCalculationType {
  AmountChanged = "AMOUNT_CHANGED",
  PercentageChanged = "PERCENTAGE_CHANGED",
  NoChange = "NO_CHANGE",
}

export enum CostBreakdownStandardField {
  Duties = "duties",
  Mpf = "mpf",
  Hmf = "hmf",
}

export enum CostBreakdownDialogType {
  GrCostBreakdown = "GR_COST_BREAKDOWN",
  ProductsCostBreakdown = "PRODUCTS_COST_BREAKDOWN",
  Cancel = "CANCEL",
}
